/**
 * Vide le cache du navigateur pour ce jeu (service worker + Cache Storage),
 * puis recharge la page pour recuperer la derniere version deployee.
 */
export async function clearCacheAndReload(): Promise<void> {
  try {
    const registrations = "serviceWorker" in navigator ? await navigator.serviceWorker.getRegistrations() : [];
    await Promise.all(registrations.map((registration) => registration.unregister()));
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } finally {
    location.reload();
  }
}
